import { Injectable, OnInit } from '@angular/core';
import {StorageService} from '../services/storage.service';
import { Constants } from '../models/constants';

const STORE_KEY = 'lastAction';

@Injectable({
    providedIn: 'root',
})
export class AutoLogoutService implements OnInit {
    private timer :any;

    constructor(private storageService:StorageService) {}

    ngOnInit(): void {
        this.initListener();
        this.reset();
    }

    private initListener() {
        document.body.addEventListener('click', () => this.reset());
        document.body.addEventListener('mouseover', () => this.reset());
        document.body.addEventListener('mouseout', () => this.reset());
        document.body.addEventListener('keydown', () => this.reset());
        document.body.addEventListener('keyup', () => this.reset());
        document.body.addEventListener('keypress', () => this.reset());
    }

    private reset() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.setLastAction(Date.now());
        this.initInterval();
    }

    private setLastAction(lastAction: number) {
        this.storageService.encodeValue(STORE_KEY, lastAction.toString());
    }

    private initInterval() {
        this.timer = setTimeout(() => {
            this.check();
        }, Constants.INACTIVITY_TIMEOUT_IN_MINS * 60 * 1000);
    }
    
    private check() {
        const now = Date.now();
        const timeForLogout = this.getLastAction() + Constants.INACTIVITY_TIMEOUT_IN_MINS * 60 * 1000;
        const diff = timeForLogout - now;
        const isTimeout = diff <= 0;
        if (isTimeout) {
            clearTimeout(this.timer);
            this.logout();
        }
    }

    private getLastAction() {
        const DECIMAL_BASE = 10;
        return parseInt(this.storageService.decodeValue(STORE_KEY), DECIMAL_BASE);
    }

    private logout() {
        localStorage.clear();
        window.location.href = 'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=' + window.location.origin;
    }
}
